import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getPrices, GetPricesParams } from '../clients/gateway.api';

export const priceCompare = createQueryKeys('priceCompare', {
    items: (params: GetPricesParams) => ({
        queryKey: [{ params }],
        queryFn: () => getPrices(params),
    }),
});
